import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { ClockIcon } from '../../atoms/icons/clock_icon';
export const SearchFilterDuration = ({ items, onClick }) => {
    return (React.createElement("div", { className: css(styles.durationGrid) }, items.map((item) => (React.createElement("div", { key: item.value, className: css(styles.card, item.selected && styles.cardOn), onClick: () => onClick(item.value) },
        React.createElement(ClockIcon, { classObject: styles.clockIcon, color: Colors.PrimaryDark, minute: item.minute }),
        React.createElement("span", null, item.name))))));
};
const styles = StyleSheet.create({
    durationGrid: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        gap: 8,
    },
    card: {
        width: 'calc(50% - 4px)',
        cursor: 'pointer',
        backgroundColor: Colors.White,
        border: `1.5px solid ${Colors.BorderLightGray}`,
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px 0',
        fontSize: 14,
        lineHeight: '140%',
        gap: 2,
    },
    cardOn: {
        borderColor: Colors.PrimaryDark,
        backgroundColor: Colors.PrimaryLighter,
    },
    clockIcon: {
        width: 25,
        height: 28,
    },
});
